<template>

  <v-container fluid fill-height>
    <v-row>
      <v-col cols="12">
        <v-row
            align="center"
            justify="center"

            style="height: 350px;"
        >
          <v-card
              class="pa-8"
              outlined
              tile
          >
            <span class="headline"
            v-if="currentState()==='staging' || currentState()==='local' ">
              ฐานข้อมูลทดสอบ
            </span>
            <span class="headline" v-else>
              ฐานข้อมูลจริง
            </span>

            <form @submit.prevent="onSubmit" class="mt-4">
              <div>
                <label class="label ma-4" for="username">Username</label>
                <input
                    id="username"
                    v-model="form.username"
                    required
                    class="login-input ma-4 pa-2"
                    placeholder="Username"
                >
                <div style="clear: both"></div>
              </div>

              <div>
                <label class="label ma-4" for="password">Password</label>
                <input
                    id="password"
                    type="password"
                    v-model="form.password"
                    required
                    class="login-input ma-4 pa-2"
                    placeholder="Password"
                />
                <div style="clear: both"></div>
              </div>
              <div class="text-center">
                <v-btn class="primary login-btn ma-4" type="submit" :loading="loading">LOGIN</v-btn>
              </div>
              <!--<a class="forgot-password" href="/password/reset">Forgot your password?</a>-->
            </form>


          </v-card>
        </v-row>
        <v-row
            align="center"
            justify="center"

            class="mt-4"
        >
          <v-col  align="center"
                  justify="center">
            <span v-if="currentState()==='staging' || currentState()==='local' " class="title">สลับไปใช้งานฐานข้อมูลจริง <a href="https://app.spacleanthailand.com">คลิ๊กที่นี่</a></span>
            <span v-else class="title">สลับไปใช้งานฐานข้อมูลทดสอบ <a href="https://jsc-test.chiangmaioutsource.com">คลิ๊กที่นี่</a></span>
            <br/>
            โหลดแอพสำหรับเปิดใช้งาน <br/>
            <a href="https://apps.apple.com/gb/app/frameless-a-full-screen-web-browser/id933580264">IOS คลิ๊กที่นี่</a>
            |
            <a href="https://play.google.com/store/apps/details?id=de.ozerov.fully">Android
              คลิ๊กที่นี่</a>

          </v-col>

        </v-row>

      </v-col>

    </v-row>
    <v-snackbar
        v-model="snackbar"
        :bottom="true"
        :right="true"
        :vertical="true"
        color="error"
        :timeout="6000"
    >
      <h5>เข้าสู่ระบบไม่สำเร็จ</h5>
      <br>
      {{ text }}
      <v-btn
          dark
          text
          @click="snackbar = false"
      >
        ปิด
      </v-btn>
    </v-snackbar>
  </v-container>


</template>

<style scoped>
  input {
    border: 1px solid #666;

  }

  .label {
    width: 100px;
    display: inline-block;
  }
</style>
<script lang="js">

  import Api from '../providers/Api'
  import Helper from '../services/Helper'

  export default {
    data () {
      return {
        form: {
          username: '',
          password: ''
        },
        loading: false,
        snackbar: false,
        text: ''
      }
    },

    created () {
      if (Helper.checkLogin()) {
        this.$router.push('/issue')
      }
    },

    methods: {
      currentState () {
        return process.env.VUE_APP_STATE
      },
      onSubmit () {
        this.loading = true

        Helper.post('/api/login', this.form, false)
          .then(({data}) => {
            Helper.setToken(data)

            this.$store.state.need_register_line = data.need_register_line
            if (this.$store.state.intended === '/profile') {
              this.$store.state.intended = '/issue'
            }

            this.$router.push(this.$store.state.intended || '/issue')
            this.$store.state.intended = null
          })
          .catch(error => {
            this.text = error.response.data.message
            this.snackbar = true
            // debugger
          })
          .finally(() => this.loading = false)
      }
    },

    mixins: [
      Api
    ]
  }

</script>
